export default __webpack_public_path__ + "static/media/hiring_proces.4c8c2869.jpg";